angular.module('services.newman.ImportService', [
  'global'
])

/**
 * The ImportService service stores methods used to access
 * system APIs.
 *
 * @class ImportService
 * @constructor
 * @module services.newman.ImportService
 */
.factory('ImportService', [
  function () {
    'use strict';

    var service = {


    };

    return service;
  }
]);
